import useSWR from 'swr';
import { parseErrorResponse } from './problem';

export type TrashKind = 'artifact' | 'repo' | 'project';

export interface TrashItem {
  kind: TrashKind;
  id: string;
  title: string;
  subtitle: string;
  project_id: string;
  project_slug: string;
  deleted_at: string;
  deleted_by: string;
  expires_at: string;
}

const fetcher = async (url: string) => {
  const r = await fetch(url, { credentials: 'include', headers: { Accept: 'application/json' } });
  if (!r.ok) throw await parseErrorResponse(r);
  return r.json();
};

export function useTrash() {
  return useSWR<TrashItem[]>('/api/v1/trash', fetcher, { refreshInterval: 30_000 });
}

export async function restoreTrash(kind: TrashKind, id: string): Promise<void> {
  const res = await fetch(`/api/v1/trash/${kind}/${id}/restore`, {
    method: 'POST', credentials: 'include',
  });
  if (!res.ok && res.status !== 204) throw await parseErrorResponse(res);
}

export async function purgeTrash(kind: TrashKind, id: string): Promise<void> {
  const res = await fetch(`/api/v1/trash/${kind}/${id}`, {
    method: 'DELETE', credentials: 'include',
  });
  if (!res.ok && res.status !== 204) throw await parseErrorResponse(res);
}
